<template>
	<div
		ref="dropdownRef"
		:class="{ navDropdown: nav, dropdown: !nav && !mobile, mobileNav: mobile }"
		class="pointer-events-auto"
		@click.stop.prevent="toggleMenu()"
	>
		<slot name="toggle"></slot>
		<div class="group/tr flex items-center">
			<slot name="label"></slot>
			<slot name="image"></slot>
			<slot name="icon"></slot>
		</div>
		<transition-slide
			:offset="offset || [0, 0]"
			:no-opacity="noOpacity"
			:duration="animDuration || 100"
			:name="mobile ? 'mobileExpand' : 'expand'"
		>
			<div v-if="open" class="dropdownPopDown closeOnMe">
				<slot name="logo"></slot>
				<ul class="closeOnMe">
					<li v-for="(item, index) in visibleItems" :key="index" class="closeOnMe">
						<a
							v-if="item.dialog"
							class="flex items-center"
							:class="{ 'gap-2': nav, 'gap-4': !nav }"
							@click.stop.prevent="openDialog(item)"
							@click="closeOnAction || item.handler ? (open = false) : null"
						>
							<div class="flex w-6 items-center justify-center">
								<span
									v-if="item.icon"
									:class="[item.icon, {}]"
									class="flex w-auto items-center justify-center"
								></span>
							</div>
							<p class="whitespace-nowrap">{{ item.label }}</p>
						</a>
						<router-link
							v-else-if="item.href"
							:to="item.href"
							class="closeOnMe relative flex items-center"
							:class="{ 'gap-2': nav, 'gap-4': !nav }"
							@click.stop.prevent="item.handler ? item.handler() : null"
							@click="closeOnAction || item.handler ? (open = false) : null"
						>
							<div class="flex w-6 items-center justify-center">
								<span
									v-if="item.icon"
									:class="[item.icon, { 'h-[30px]': mobileNav, 'h-4': !mobileNav }]"
									class="flex w-auto items-center justify-center"
								></span>
							</div>
							<p class="whitespace-nowrap">{{ item.label }}</p>
						</router-link>
						<a
							v-else
							class="closeOnMe flex items-center"
							:class="{ 'gap-2': nav, 'gap-4': !nav }"
							@click.stop.prevent="item.handler ? item.handler() : null"
							@click="closeOnAction || item.handler ? (open = false) : null"
						>
							<div class="flex w-6 items-center justify-center">
								<span
									v-if="item.icon"
									:class="[item.icon, { 'h-[30px]': mobileNav, 'h-4': !mobileNav }]"
									class="flex w-auto items-center justify-center"
								></span>
							</div>
							<p class="whitespace-nowrap">{{ item.label }}</p>
						</a>
					</li>
				</ul>
			</div>
		</transition-slide>
	</div>
</template>

<script>
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

export default {
	props: {
		items: {
			type: Array,
			required: true
		},
		nav: {
			type: Boolean,
			default: false
		},
		mobile: {
			type: Boolean,
			default: false
		},
		mobileNav: {
			type: Boolean,
			default: false
		},
		offset: {
			type: Array,
			default: () => [0, 0]
		},
		noOpacity: {
			type: Boolean,
			default: false
		},
		animDuration: {
			type: Number,
			default: 100
		},
		closeOnAction: {
			type: Boolean,
			default: false
		}
	},

	setup() {
		const dropdownRef = ref(null)
		const open = ref(false)

		onClickOutside(dropdownRef, () => {
			open.value = false
		})

		return { open, dropdownRef }
	},

	computed: {
		visibleItems() {
			return this.items.filter((item) => !item.hidden)
		}
	},

	beforeUnmount() {
		document.removeEventListener('click', this.closeMenu)
	},

	methods: {
		toggleMenu() {
			this.open = !this.open
			if (this.open) {
				document.addEventListener('click', this.closeMenu)
			} else {
				document.removeEventListener('click', this.closeMenu)
			}
		},
		closeMenu(event) {
			if (!event.target.classList.contains('closeOnMe')) {
				this.open = false
				document.removeEventListener('click', this.closeMenu)
			}
		},
		openDialog(item) {
			if (item.dialog && item.handler) {
				item.handler()
			}
		}
	}
}
</script>
